import { Component, input } from '@angular/core';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrl: './panel.component.scss',
  standalone: true,
})
export class PanelComponent {
  readonly panelSpacing = input<'xs' | 'sm' | 'md' | 'lg' | 'xl'>('md');
}
